import EventEmitter from 'events';

const spEventEmitter = new EventEmitter();

export default spEventEmitter;